// extracted by mini-css-extract-plugin
module.exports = {"InlineEmbed":"InlineEmbed_InlineEmbed__1pbcW","EmbedContainer":"InlineEmbed_EmbedContainer__gLjYa","Caption":"InlineEmbed_Caption__1fnu2"};